import './App.css';
import React, { Suspense, lazy } from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ProtectedRoute from './Components/ProtectedRoute';

const Home = lazy(() => import('./Pages/Home'));
const RestaurantList = lazy(() => import('./Pages/RestaurantList'));
const MenusList = lazy(() => import('./Pages/MenusList'));
const RecipesList = lazy(() => import('./Pages/RecipesList'));
const RestaurantDetail = lazy(() => import('./Pages/RestaurantDetail'));
const RecipeDetail = lazy(() => import('./Pages/RecipeDetail'));
const SignIn = lazy(() => import('./Pages/SignIn'));
const SignUp = lazy(() => import('./Pages/SignUp'));
const OAuthCallback = lazy(() => import('./Pages/OAuthCallback'));
const VerifyEmail = lazy(() => import('./Pages/VerifyEmail'));
const ForgotPassword = lazy(() => import('./Pages/ForgotPassword'));
const Role = lazy(() => import('./Pages/Role'));
const ProfileC = lazy(() => import('./Pages/ProfileC'));
const ProfileR = lazy(() => import('./Pages/ProfileR'));
const AddMenu = lazy(() => import('./Pages/AddMenu'));
const MenuDetail = lazy(() => import('./Pages/MenuDetail'));
const AddRecipe = lazy(() => import('./Pages/AddRecipe'));
const ModifyMenu = lazy(() => import('./Pages/ModifyMenu'));
const ModifyRecipe = lazy(() => import('./Pages/ModifyRecipe'));
const SurveyList = lazy(() => import('./Pages/SurveyList'));
const SurveyDetail = lazy(() => import('./Pages/SurveyDetail'));
const SurveyAdmin = lazy(() => import('./Pages/SurveyAdmin'));
const SurveyResponses = lazy(() => import('./Pages/SurveyResponses'));
const StatisticalObservatory = lazy(() => import('./Pages/StatisticalObservatory'));
const DataManagement = lazy(() => import('./Pages/DataManagement'));
const SimpleDataManagement = lazy(() => import('./Pages/SimpleDataManagement'));
const UserManagement = lazy(() => import('./Pages/UserManagement'));
const SystemSettings = lazy(() => import('./Pages/SystemSettings'));
const AdminDashboard = lazy(() => import('./Pages/AdminDashboard'));
const RestaurantDashboard = lazy(() => import('./Pages/RestaurantDashboard'));
const CustomerDashboard = lazy(() => import('./Pages/CustomerDashboard'));
const CustomerStatisticalObservatory = lazy(() => import('./Pages/CustomerStatisticalObservatory'));
const RestaurantStatisticalObservatory = lazy(() => import('./Pages/RestaurantStatisticalObservatory'));
const ActivityLogs = lazy(() => import('./Pages/ActivityLogs'));

const PageLoader = () => (
  <div className="flex min-h-screen items-center justify-center">
    <div className="h-8 w-8 animate-spin rounded-full border-4 border-emerald-600 border-t-transparent" />
  </div>
);

function App() {

  return (

   <div className="App surface-page">
        <BrowserRouter>
        <main className="flex min-h-0 w-full flex-1 flex-col">
            <Suspense fallback={<PageLoader />}>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/rlist" element={<RestaurantList />} />
                <Route path="/menulist" element= { <MenusList/> } />
                <Route path="/recipelist" element= { <RecipesList/> } />
                <Route path="/restaurant/:id" element= { <RestaurantDetail/> } />
                <Route path="/getMenu/:id" element= { <MenuDetail/> } />
                <Route path="/recipedetail/:id" element= { <RecipeDetail/> } />
                <Route path="/signin" element= { <SignIn/> } />
                <Route path="/signup" element= { <SignUp/> } />
                <Route path="/oauth/callback" element={ <OAuthCallback/> } />
                <Route path="/verify-email" element= { <VerifyEmail/> } />
                <Route path="/forgot-password" element= { <ForgotPassword/> } />
                <Route path="/profileC" element= { <ProtectedRoute roles={['customer','admin']}><ProfileC/></ProtectedRoute> } />
                <Route path="/profileR" element= { <ProtectedRoute roles={['restaurant','admin']}><ProfileR/></ProtectedRoute> } />
                <Route path="/authpage" element={<Navigate to="/signin" replace />} />
                <Route path="/role" element= { <ProtectedRoute><Role/></ProtectedRoute> } />
                <Route path="/addmenu" element= { <ProtectedRoute roles={['restaurant','admin']}><AddMenu/></ProtectedRoute> } />
                <Route path="/addrecipe" element= { <ProtectedRoute roles={['restaurant','admin']}><AddRecipe/></ProtectedRoute> } />
                <Route path="/modifyMenu/:id" element= { <ProtectedRoute roles={['restaurant','admin']}><ModifyMenu/></ProtectedRoute> } />
                <Route path="/modifyRecipe/:id" element= { <ProtectedRoute roles={['restaurant','admin']}><ModifyRecipe/></ProtectedRoute> } />
                <Route path="/surveys" element= { <SurveyList/> } />
                <Route path="/survey/:id" element= { <SurveyDetail/> } />
                <Route path="/survey-admin" element= { <ProtectedRoute roles={['admin']}><SurveyAdmin/></ProtectedRoute> } />
                <Route path="/survey-admin/:id/responses" element= { <ProtectedRoute roles={['admin']}><SurveyResponses/></ProtectedRoute> } />
                <Route path="/statistical-observatory" element= { <ProtectedRoute roles={['admin']}><StatisticalObservatory/></ProtectedRoute> } />
                <Route path="/data-management" element= { <ProtectedRoute roles={['admin']}><DataManagement/></ProtectedRoute> } />
                <Route path="/simple-data-management" element= { <ProtectedRoute><SimpleDataManagement/></ProtectedRoute> } />
                <Route path="/user-management" element= { <ProtectedRoute roles={['admin']}><UserManagement/></ProtectedRoute> } />
                <Route path="/system-settings" element= { <ProtectedRoute roles={['admin']}><SystemSettings/></ProtectedRoute> } />
                <Route path="/dashboard" element={<Navigate to="/data-management?tab=dashboard" replace />} />
                <Route path="/admin-dashboard" element= { <ProtectedRoute roles={['admin']}><AdminDashboard/></ProtectedRoute> } />
                <Route path="/restaurant-dashboard" element= { <ProtectedRoute roles={['restaurant','admin']}><RestaurantDashboard/></ProtectedRoute> } />
                <Route path="/customer-dashboard" element= { <ProtectedRoute roles={['customer','admin']}><CustomerDashboard/></ProtectedRoute> } />
                <Route path="/customer-statistical-observatory" element= { <ProtectedRoute roles={['customer','admin']}><CustomerStatisticalObservatory/></ProtectedRoute> } />
                <Route path="/restaurant-statistical-observatory" element= { <ProtectedRoute roles={['restaurant','admin']}><RestaurantStatisticalObservatory/></ProtectedRoute> } />
                <Route path="/activity-logs" element= { <ProtectedRoute roles={['admin']}><ActivityLogs/></ProtectedRoute> } />
                <Route path="*" element={<Navigate to="/" replace />} />
                
            </Routes>
            </Suspense>
        </main>
        </BrowserRouter>
   </div>   
  );
}                                                                                      

export default App;